import React from 'react';
import '../css/Splash.css';
import { Link } from 'react-router-dom';

const containerStyle = {
  maxWidth: '900px',
  margin: '0 auto',
  padding: '2.5rem 1rem 1.5rem 1rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

// Placeholder video URL and screenshots
const VIDEO_URL = 'https://youtu.be/x8PuQQSS2Rc'; // Replace with demo video URL.
const SCREENSHOTS = [
  require('../assets/webpage1.jpg'),
  require('../assets/webpage 2.jpg'),
  require('../assets/webpage 3.jpg'),
   require('../assets/webpage 4.jpg'),
];

const Marketing = () => {
  return (
    <div className="splash-container" style={containerStyle}>
      <header className="splash-header" style={{marginBottom: '1.1rem'}}>
        <h1 style={{fontWeight: 700, fontSize: '2.5rem', letterSpacing: '0.5px'}}>Garnet & Code</h1>
        <p className="splash-tagline" style={{fontWeight: 500, fontSize: '1.2rem', color: '#e74c3c', margin: '0.5rem 0 1.2rem 0'}}>Your Ultimate Sports Matchup & Prediction App</p>
      </header>
      <section className="splash-video-section" style={{marginBottom: '1.1rem'}}>
        <h2 style={{fontWeight: 700, fontSize: '2rem', color: 'white', marginBottom: '0.7rem'}}>See It In Action </h2>
        <p><i>(placeholder)</i></p>
        <div className="splash-video-wrapper">
          <iframe
                    width="800"
                    height="450"
                    src="https://www.youtube.com/embed/x8PuQQSS2Rc?modestbranding=1&rel=0&iv_load_policy=3"
                    title="YouTube video"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    id="demo-video"
          />
        </div>
      </section>
      <section className="splash-description" style={{marginBottom: '1.1rem'}}>
        <h2 style={{color: '#e74c3c', fontWeight: 700, fontSize: '1.5rem', marginBottom: '0.5rem'}}>Why Use Garnet & Code?</h2>
        <p style={{color: 'white', fontSize: '1.1rem', marginBottom: '0.7rem'}}>
          Garnet & Code helps sports fans track matchups, view team stats, and make predictions for football and soccer leagues. Whether you want to follow your favorite teams, test your sports knowledge, learns some fun facts or just play some cool games, our app has you covered!
        </p>
        <h3 style={{color: '#e74c3c', fontWeight: 600, marginBottom: '0.3rem'}}>How It Works</h3>
        <ol style={{color: 'white', fontSize: '1.05rem', paddingLeft: '1.2rem'}}>
          <li>Sign up or log in to your account.</li>
          <li>Browse upcoming sports games, team stats, and league standings.</li>
          <li>Make predictions, play trivia games, and save your favorite teams.</li>
          <li>Track your progress and see how well you did!</li>
        </ol>
      </section>
      <section className="splash-screenshots" style={{marginBottom: '1.1rem'}}>
        <h2 style={{fontWeight: 700, fontSize: '2rem', color: 'white', marginBottom: '0.7rem'}}>App Screenshots</h2>
        <div className="splash-screenshot-list">
          {SCREENSHOTS.map((src, idx) => (
            <img key={idx} src={src} alt={`App screenshot ${idx + 1}`} className="splash-screenshot" />
          ))}
        </div>
      </section>
      <section className="splash-about" style={{marginBottom: '1.1rem'}}>
        <h2 style={{fontWeight: 700, fontSize: '2rem', color: 'white', marginBottom: '0.7rem'}}>About the Team</h2>
        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem'}}>
          <div style={{background: '#232e3b', borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.18)', padding: '1.5rem 2.5rem', minWidth: '220px', textAlign: 'center', color: 'white', fontWeight: 500}}>
            <div style={{fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.3rem'}}>Alayna Wybranski</div>
            <div style={{color: '#b0b8c1', fontSize: '1rem'}}>alaynaaw@email.sc.edu</div>
          </div>
          <div style={{background: '#232e3b', borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.18)', padding: '1.5rem 2.5rem', minWidth: '220px', textAlign: 'center', color: 'white', fontWeight: 500}}>
            <div style={{fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.3rem'}}>Ava Patel</div>
            <div style={{color: '#b0b8c1', fontSize: '1rem'}}>avamp@email.sc.edu</div>
          </div>
          <div style={{background: '#232e3b', borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.18)', padding: '1.5rem 2.5rem', minWidth: '220px', textAlign: 'center', color: 'white', fontWeight: 500}}>
            <div style={{fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.3rem'}}>Cyrus Zheng</div>
            <div style={{color: '#b0b8c1', fontSize: '1rem'}}>zhengc@email.sc.edu</div>
          </div>
          <div style={{background: '#232e3b', borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.18)', padding: '1.5rem 2.5rem', minWidth: '220px', textAlign: 'center', color: 'white', fontWeight: 500}}>
            <div style={{fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.3rem'}}>Lee Moorman</div>
            <div style={{color: '#b0b8c1', fontSize: '1rem'}}>moormang@email.sc.edu</div>
          </div>
          <div style={{background: '#232e3b', borderRadius: '16px', boxShadow: '0 2px 12px rgba(0,0,0,0.18)', padding: '1.5rem 2.5rem', minWidth: '220px', textAlign: 'center', color: 'white', fontWeight: 500}}>
            <div style={{fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.3rem'}}>Maurice Hooks</div>
            <div style={{color: '#b0b8c1', fontSize: '1rem'}}>mthooks@email.sc.edu</div>
          </div>
        </div>
      </section>
      <footer className="splash-footer" style={{marginTop: '1.5rem'}}>
        <a
          href="https://github.com/SCCapstone/GarnetAndCode"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            background: '#232e3b',
            color: 'white',
            borderRadius: '2rem',
            padding: '0.6rem 1.5rem',
            fontWeight: 600,
            fontSize: '1.1rem',
            textDecoration: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
            gap: '0.7rem',
            transition: 'background 0.2s',
          }}
          onMouseOver={e => e.currentTarget.style.background = '#1a222c'}
          onMouseOut={e => e.currentTarget.style.background = '#232e3b'}
        >
          <svg height="22" width="22" viewBox="0 0 16 16" fill="currentColor" style={{marginRight: '0.3rem'}} aria-hidden="true">
            <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z"
            />
          </svg>
          View on GitHub
        </a>
      </footer>
    </div>
  );
};

export default Marketing;
